import { IProduct } from '@/context/ProductDataStore'

type ProductWithImages = IProduct & {
  heroImage?: unknown
  images?: unknown
}

// Bundled thumbnails, only for items the product API has no image for (e.g. Custom,
// Engraving). New colourways must get their thumbnail from the API, not from here.
export const getLegacyThumbnailPath = (productId: string): string =>
  `/assets/images/product_thumbnails/${productId}.webp`

export const getProductThumbnailUrl = (
  product: IProduct | null | undefined
): string | null => {
  if (!product) {
    return null
  }

  const record = product as ProductWithImages
  const heroImage = record.heroImage
  if (heroImage && typeof heroImage === 'object') {
    if ('thumbnailUrl' in heroImage && typeof heroImage.thumbnailUrl === 'string') {
      return heroImage.thumbnailUrl
    }
    const heroRecord = heroImage as unknown as Record<string, unknown>
    const heroThumbnail =
      heroRecord.thumbnailUrl ||
      heroRecord.thumbnail_url ||
      heroRecord.thumbnail ||
      heroRecord.thumb
    if (typeof heroThumbnail === 'string') {
      return heroThumbnail
    }
  }

  const images = record.images
  if (Array.isArray(images) && images.length) {
    const first = images[0]
    if (typeof first === 'string') {
      return first
    }
    if (first && typeof first === 'object') {
      const imageRecord = first as Record<string, unknown>
      const thumbnail =
        imageRecord.thumbnailUrl ||
        imageRecord.thumbnail_url ||
        imageRecord.thumbnail ||
        imageRecord.thumb
      if (typeof thumbnail === 'string') {
        return thumbnail
      }
      const url = imageRecord.url || imageRecord.imageUrl || imageRecord.primary || imageRecord.src
      if (typeof url === 'string') {
        return url
      }
    }
  }

  if (typeof record.imageUrl === 'string') {
    return record.imageUrl
  }

  return null
}
